import { ReactComponent as ArrowLeftIcon } from './arrow-left-icon.svg';
import { ReactComponent as EyeClosedIcon } from './eye-closed-icon.svg';
import { ReactComponent as EyeIcon } from './eye-open-icon.svg';
import { ReactComponent as TickIcon } from './tick-icon.svg';
import { ReactComponent as CloseIcon } from './close-icon.svg';
import { ReactComponent as AlertCross } from './alert-cross.svg';
import { ReactComponent as CloseIconGray } from './close-gray.svg';
import { ReactComponent as PasswordSuccessTick } from './password-success-tick.svg';
import { ReactComponent as IndividualIcon } from './individual-icon.svg';
import { ReactComponent as FamilyIcon } from './family-icon.svg';
import { ReactComponent as FamilyIconPlus } from './family-icon-plus.svg';
import { ReactComponent as PricingArrow } from './arrow-pricing.svg';
import { ReactComponent as CreditCardIcon } from './credit-card-icon.svg';
import { ReactComponent as BankTransferIcon } from './bank-tranfer-icon.svg';
import { ReactComponent as InfoIcon } from './info-icon.svg';
import { ReactComponent as PaymentSuccessIcon } from './payment-success-icon.svg';
import { ReactComponent as HeaderLogo } from './header-logo.svg';
import { ReactComponent as PaymentFailedIcon } from './payment-failed.svg';
import { ReactComponent as FavoritesIcon } from './favorite-icon.svg';
import { ReactComponent as PhotosIcon } from './photos-icon.svg';
import { ReactComponent as PeopleIcon } from './people-icon.svg';
import { ReactComponent as MemoriesIcon } from './memories-icon.svg';
import { ReactComponent as FamilyTreeIcon } from './family-tree-icon.svg';
import { ReactComponent as RecipesIcon } from './recipie-icon.svg';
import { ReactComponent as SharingIcon } from './share-icon.svg';
import { ReactComponent as StorageIcon } from './storage-icon.svg';
import { ReactComponent as TrashIcon } from './trash-icon.svg';
import { ReactComponent as CameraIcon } from './upload-image-icon.svg';
import { ReactComponent as UploadModalIcon } from './upload-modal-icon.svg';
import { ReactComponent as ProfileEditIcon } from './profile-edit-icon.svg';
import { ReactComponent as LogoutIcon } from './logout-icon.svg';
import { ReactComponent as PersonIcon } from './person-icon.svg';
import { ReactComponent as DashboardIcon } from './dashboard-icon.svg';
import { ReactComponent as SettingsIcon } from './settings-icon.svg';
import { ReactComponent as PencilIcon } from './pencil-icon.svg';
import { ReactComponent as TakePicIcon } from './take-picture-icon.svg';
import { ReactComponent as RemoveIcon } from './trash-green-icon.svg';
import { ReactComponent as UploadIcon } from './upload-icon.svg';
import { ReactComponent as ModalUploadIcon } from './modal-upload-icon.svg';
import { ReactComponent as AddRoundIcon } from './add.svg';
import { ReactComponent as SubscriptionIcon } from './subscription-icon.svg';
import { ReactComponent as PaymentsIcon } from './payments-icon.svg';
import { ReactComponent as SecurityPrivacy } from './security-privacy.svg';
import { ReactComponent as Notification } from './notification-icon.svg';
import { ReactComponent as Help } from './help.svg';
import { ReactComponent as Delete } from './delete-icon.svg';
import { ReactComponent as Visa } from './visa.svg';
import { ReactComponent as Master } from './master.svg';
import { ReactComponent as AlertCheck } from './alert-check.svg';
import { ReactComponent as AlertError } from './alert-error.svg';
import { ReactComponent as AlertInfo } from './alert-info.svg';
import { ReactComponent as AlertWarning } from './alert-warning.svg';
import { ReactComponent as CloseBtn } from './close-btn.svg';
import { ReactComponent as SeeMore } from './see-more.svg';
import { ReactComponent as ChangeSubscription } from './change-sub-icon.svg';
import { ReactComponent as CancelSubscription } from './cancel-sub-icon.svg';
import { ReactComponent as AmpleIcon } from './ample-icon.svg';
import { ReactComponent as AnywhereAccess } from './anywhere-access-icon.svg';
import { ReactComponent as Privacy } from './privacy-icon.svg';
import { ReactComponent as Seamless } from './seamless-collab.svg';
import { ReactComponent as Backup } from './automatic-backup.svg';
import { ReactComponent as PlusRounded } from './plus-rounded.svg';
import { ReactComponent as Folder } from './folder-icon.svg';
import { ReactComponent as ThreeDots } from './three-dots.svg';
import { ReactComponent as ListIcon } from './list-icon.svg';
import { ReactComponent as GridIcon } from './grid-icon.svg';
import { ReactComponent as Bank } from './bank.svg';
import { ReactComponent as Card } from './card.svg';
import { ReactComponent as SubscriptionSelected } from './subscription-selected.svg';
import { ReactComponent as PaymentSelected } from './payment-selected.svg';
import { ReactComponent as SecuritySelected } from './security-selected.svg';
import { ReactComponent as NotificationSelected } from './notification-selected.svg';
import { ReactComponent as HelpSelected } from './help-selected.svg';

export const SVGAssets = {
  AlertCheck,
  AlertError,
  AlertInfo,
  AlertWarning,
  ArrowLeftIcon,
  EyeClosedIcon,
  EyeIcon,
  TickIcon,
  CloseIcon,
  AlertCross,
  CloseIconGray,
  PasswordSuccessTick,
  IndividualIcon,
  FamilyIcon,
  FamilyIconPlus,
  PricingArrow,
  CreditCardIcon,
  BankTransferIcon,
  InfoIcon,
  PaymentSuccessIcon,
  HeaderLogo,
  PaymentFailedIcon,
  FavoritesIcon,
  PhotosIcon,
  PeopleIcon,
  MemoriesIcon,
  FamilyTreeIcon,
  RecipesIcon,
  SharingIcon,
  StorageIcon,
  TrashIcon,
  CameraIcon,
  UploadModalIcon,
  ProfileEditIcon,
  PersonIcon,
  LogoutIcon,
  DashboardIcon,
  SettingsIcon,
  PencilIcon,
  TakePicIcon,
  RemoveIcon,
  UploadIcon,
  ModalUploadIcon,
  AddRoundIcon,
  SubscriptionIcon,
  PaymentsIcon,
  SecurityPrivacy,
  Notification,
  Help,
  Delete,
  Master,
  Visa,
  CloseBtn,
  SeeMore,
  ChangeSubscription,
  CancelSubscription,
  AmpleIcon,
  AnywhereAccess,
  Privacy,
  Seamless,
  Backup,
  PlusRounded,
  Folder,
  ThreeDots,
  ListIcon,
  GridIcon,
  Bank,
  Card,
  SubscriptionSelected,
  PaymentSelected,
  SecuritySelected,
  NotificationSelected,
  HelpSelected
};
